import React from 'react'
import './TopSection.scss';
import styled from 'styled-components';
import { get_data, API_URL, isMobile, isIos } from '../../static/helper';
import Slider from '../Slider/Slider';
import { GA_Event } from '../Analytics/Analytics';

const ArticleGallery = (props) => {
    return (
        <div onClick={() => { GA_Event("Article_Clicked", props.link); window.open(props.link, "_blank") }} className="article-container">
            <img src={props.image.replace("http:", "https:")}></img>
            <div className="desc-container">
                <div className="desc">
                    {props.title}
                </div>
                <a href={props.link} target="_blank" className="read-more">קרא עוד</a>
            </div>
        </div>
    )
}


const TopImage = styled.div`
    position: relative;
    background-attachment: fixed;
    overflow: hidden;
    background-image: url(${props => props.image});
    background-repeat: no-repeat;
    width: 100vw;
    height: ${740 / 1920 * 100}vw;
    background-size: 100vw;
    @media only screen and (max-width: 750px) {
        height: ${920 / 640 * 100}vw;
        background-size: cover;
        background-position: center;
        background-attachment: unset;
    }
        `;

class TopSection extends React.Component {
    state = {
        topData: {},
        sliderData: []
    };
    componentDidMount = async () => {
        window.addEventListener("scroll", (event) => this.wrapperScrolling(event));
        let sliderGalleryItems = await get_data("/api/home");
        if(sliderGalleryItems !== null){
        this.setState({
            topData: await get_data(`${process.env.PUBLIC_URL}/Data/data.json`, true),
            sliderData: sliderGalleryItems.rss.channel.item
        })
    }
    }
    wrapperScrolling(e) {
        const sTop = window.scrollY || 0;
        if (!isMobile() && !isIos()) {
            document.querySelector(".top-image").style.backgroundPositionY = `${-sTop / 3}px`
        }
    }
    setOwlRef = (ref) => {
        this.setState({
            OwlRef: ref
        })
    }
    render() {
        let sliderData = [];
        if(Array.isArray(this.state.sliderData)) {
            this.state.sliderData.map((item, index) => {
                if (item.link !== this.state.topData.Link) {
                    sliderData.push(<ArticleGallery key={index} {...item} />)
                }
            })
        } else{

            sliderData.push(<ArticleGallery {...this.state.sliderData} />)
        }
        const imagePath = this.state.topData.Image ? `${process.env.PUBLIC_URL}/Data/${isMobile() || isIos() ? this.state.topData.Image.split("|")[1] : this.state.topData.Image.split("|")[0]}` : "";
        return (
            <div className="section top-section">
                <TopImage image={imagePath} className="top-image">
                    <div className="top-desc-container">
                        <div>
                            <a href={this.state.topData.Link} target="_blank" className="title" onClick={() => GA_Event("Article_Clicked", this.state.topData.Link)}>{this.state.topData.Title}</a>
                        </div>
                        <div className="desc-wrapper">
                            <a className="desc" href={this.state.topData.Link} target="_blank" onClick={() => GA_Event("Article_Clicked", this.state.topData.Link)}>
                                {this.state.topData.SubTitle}
                            </a><br />
                            <a href={this.state.topData.Link} onClick={() => GA_Event("Article_Clicked", this.state.topData.Link)} target="_blank" className="read-more">קרא עוד</a>
                        </div>
                    </div>
                </TopImage>
                {sliderData.length > 0 ?
                    <div className="slider-container" id="slider-container">
                        <div className="slider">
                            <Slider
                                setOwlRef={this.setOwlRef}
                                margin={35}
                                navSpeed={1000}
                                center={false}>
                                {sliderData}
                            </Slider>
                        </div>
                        <div className="arrows">
                            <div onClick={() => {
                                this.state.OwlRef != null ? this.state.OwlRef.prev(600) : null
                            }} className="arrow right"></div>
                            <div onClick={() => {
                                this.state.OwlRef != null ? this.state.OwlRef.next(600) : null
                            }} className="arrow left"></div>
                        </div>
                    </div>
                    : ""
                }
                <h1 className="s-title">אירווזיון 2019 בתל אביב</h1>
            </div>
        );
    }
}

export default TopSection;


// WEBPACK FOOTER //
// ./src/Components/TopSection/TopSection.js